module.exports = __webpack_public_path__ + "static/img/player_head_15.c5d2161.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_15.jpg
// module id = 325i
// module chunks = 1